import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import {Button} from '@chakra-ui/react';
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';

export function ScheduleClassModal({subscription_id, language_name, level_name, no_of_sessions, setShowScheduleModal, sessions_array, tutor_avail}) {
  const [classSchedule, setClassSchedule] = useState([]);
  const {setTostMessage} = useContext(TostMessageContext);
  const {logOutFunction} = useContext(UserContext)
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const navigate = useNavigate();

  const setTime = async (time, session) => {
    const new_array = classSchedule;
    const index = new_array.findIndex(item => item.schedule_id === session);
    if (index !== -1) {
        // Update existing
        new_array[index] = {schedule_id: session, time: time};
    } else {
        // Add new
        new_array.push({schedule_id: session, time: time});
    }
    setClassSchedule(new_array);
  }

  const scheduleClasses = async () => {
    const formData = new FormData();
    formData.append('subscription_id', subscription_id);
    formData.append('schedule', JSON.stringify(classSchedule));

    setLoading(true);
    try {
        const response = await axios.post(base_url + '/classes/schedule-private-class.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoading(false);
            setTostMessage({
                messageType: "success",
                message: response.data.response,
            });
            setTimeout(() => {
                navigate("/my-classes");
            }, 1000)
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[350px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px]'>
                <div onClick={() => setShowScheduleModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                <a className='text-dark text-[20px] font-bold'>Schedule Classes</a>
                <div className='w-[80%] mt-2 flex flex-col justify-start cursor-pointer'>
                    <a className='text-dark mx-auto text-[15px] font-semibold'>{language_name} ({level_name})</a>
                    <a className='text-dark mx-auto text-[15px] font-semibold'>{no_of_sessions} Session(s)</a>
                    <a className='text-dark mx-auto text-[15px] mt-1'>My available days: {tutor_avail}</a>
                </div>
                <div className='w-[80%] my-2 flex flex-col'>
                    {sessions_array?.map((session, index) => (
                        <div className='my-2'>
                        <label>Class {++index}</label>
                        <input className='p-3 border border-1 w-full rounded-[5px] my-1' key={index} type='datetime-local' value={classSchedule[classSchedule.findIndex(item => item.schedule_id === session.schedule_id)]?.time != null ? classSchedule[classSchedule.findIndex(item => item.schedule_id === session.schedule_id)]?.time : session.current_time} onChange={(e) => setTime(e.target.value, session.schedule_id)} />
                        </div>
                    ))}
                </div>
                <button
                    onClick={() => loading ? null : scheduleClasses()}
                    className="w-[80%] mx-auto bg-yellow hover:bg-yellow-500 text-black font-medium py-2 rounded-md transition"
                >
                    {loading ? (
                        <ClockLoader
                            color={'#212121'}
                            loading={loading}
                            size={25}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            className='mx-auto'
                        />
                        ) : 'Submit'
                    }
                </button>
                <a className='text-xs text-orange w-[60%] mt-3 mx-auto text-center'>You will be notified ahead should the student reschedule a class</a>
            </div>  
        </div>
    )
}

